
import Vue from 'vue'
import axios from 'axios'
import * as Sentry from '@sentry/vue'
import { Component } from 'vue-property-decorator'
import { DistributorRelationship } from '../../global/models'
import DistributorForm from '../components/DistributorForm.vue'
import { consumeError } from '../../global/utils'

@Component({
  components: { DistributorForm }
})
export default class ProviderReadPage extends Vue {
  relationship: Partial<DistributorRelationship> = {}
  
  get agencyId() {
    return this.$store.state.auth.agencyId
  }

  async submit() {
    try {
      if (this.relationship.distributorLimitPercentage) {
        this.relationship.distributorLimitPercentage = 100 - this.relationship.distributorLimitPercentage
      }
      const data = { distributorId: this.relationship.distributorId, distributorLimitPercentage: this.relationship.distributorLimitPercentage }
      const response: any = await axios.post('/distributors', data)
      this.$router.replace({ name: 'distributors-read', params: { id: response.data.id.toString() } })
    } catch (error: any) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }
}
